// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-tag[data-v-96f9c8da] {\n  background-color: #f8f8f8;\n}\n.text-tag[data-v-96f9c8da]:focus {\n  background-color: #f8f8f8;\n}\n.heading[data-v-96f9c8da] {\n  font-weight: normal !important;\n}", ""]);
// Exports
module.exports = exports;
